<template>
  <div class="hotel-map">
    <div class="map-header">
      <h3>
        <i
          class="fa fa-times close-icon"
          @click="showMap(false)"
        />
        {{ brandName }} Exclusive Hotel
      </h3>
    </div>
    <div
      id="hotels-map"
      class="map-details"
    />
    <div
      id="map-legend"
      class="map-legend"
    >
      <img src="http://maps.google.com/mapfiles/ms/icons/green-dot.png">Event Location
      <img src="http://maps.google.com/mapfiles/ms/icons/red-dot.png">Exclusive Hotels
      <img src="http://maps.google.com/mapfiles/ms/icons/purple-dot.png">Additional Hotels
    </div>
    <div class="hotel-info">
      <RetailHotelCard
        v-if="selectedHotel"
        :hotel="selectedHotel"
      />
    </div>
    <div class="hotels-distance" />
  </div>
</template>

<script>

import RetailHotelCard from './retail_hotel_card'
import { mapMutations, mapGetters } from 'vuex'
/* global google */

export default {
  components: {
    RetailHotelCard
  },

  data() {
    return {
      eventLatLng: null,
      map: null,
      selectedHotel: null,
      previousMarker: null,
      brandName: window.brand_name
    }
  },

  computed: {
    ...mapGetters('hotel', ['getLowestValue', 'getContractedHotels'])
  },

  watch: {
    map() {
      const contractedOnly = this.$store.state.hotel.contractedOnlyMap

      this.createEventMarker()

      if (contractedOnly) {
        this.createHotelMarkers(this.getContractedHotels)
      } else {
        this.createHotelMarkers(this.$store.state.hotel.hotels)
      }
    }
  },

  mounted() {
    try {
      const eventLat = this.$store.state.hotel.eventLatitude
      const eventLng = this.$store.state.hotel.eventLongitude
      this.eventLatLng = new google.maps.LatLng(eventLat, eventLng)
      this.map = new google.maps.Map(document.getElementById('hotels-map'), {
        zoom: 1,
        center: this.eventLatLng,
        fullscreenControl: false,
        streetViewControl: false
      })

      let legend = document.getElementById('map-legend')
      this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(legend)
    } catch (error) {
      alert(error)
    }
  },

  methods: {
    ...mapMutations('hotel', ['showMap']),
    createEventMarker() {
      new google.maps.Marker({
        map: this.map,
        position: this.eventLatLng,
        icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
      })
    },
    createHotelMarkers(hotels) {


      for (let i = 0; i < hotels.length; i++) {
        const hotel = hotels[i]
        const hotelLocation = {
          lat: hotel.latitude,
          lng: hotel.longitude
        }
        const lowestValue = this.getLowestValue(hotel.id) / hotel.stayDuration
        const icon = hotel.contracted ?
          'http://maps.google.com/mapfiles/ms/icons/red-dot.png' :
          'http://maps.google.com/mapfiles/ms/icons/purple-dot.png'

        const marker = new google.maps.Marker({
          map: this.map,
          position: hotelLocation,
          animation: google.maps.Animation.DROP,
          label: {
            text: `$${(lowestValue.toFixed(0)).toString()}`
          },
          icon: {
            url: icon,
            labelOrigin: new google.maps.Point(16,38)
          }
        })

        google.maps.event.addListener(marker, 'click', () => {
          if (this.previousMarker) {
            this.previousMarker.marker.setIcon(this.previousMarker.icon)
          }
          this.previousMarker = {marker: marker, icon: marker.getIcon()}
          marker.setIcon('http://maps.google.com/mapfiles/ms/icons/blue-dot.png')
          this.selectedHotel = hotel
        })
      }
    },
  }
}
</script>
